<template>
  <div class="not-found-container">
    <img src="/images/404-illustration.svg" alt="404" />
    <h1>Oops! This Page Could Not Be Found</h1>
    <p>
      Sorry but the page you are looking for is not here, <br />
      Want to try search in our home page?
    </p>
    <BaseButton
      variant="primary"
      class-name="go-home-button"
      @click="handleClick"
    >
      Go back to home
    </BaseButton>
  </div>
</template>

<script setup>
import BaseButton from "@/components/common/BaseButton.vue";
import { useRouter } from "vue-router";

const router = useRouter();

const handleClick = () => {
  router.push({ name: "HomePage" });
};
</script>

<style scoped>
.not-found-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.25rem;
  height: 100vh;
}

h1 {
  font-size: 2.25rem;
  font-weight: bold;
  color: var(--primary-blue);
}

p {
  color: #6b7280;
  font-size: 1.25rem;
  text-align: center;
}

.go-home-button {
  padding-left: 8rem;
  padding-right: 8rem;
}
</style>
